import type { Locale } from './types';

const SUPPORTED: readonly Locale[] = ['en', 'fr', 'es'];

/**
 * Resolves the best supported locale from the available candidates.
 *
 * Resolution order:
 *   1. `initLang` from the `7punches:init` postMessage payload
 *   2. `navigatorLang` (defaults to `navigator.language`)
 *   3. `'en'` fallback
 *
 * Matching is BCP-47 aware: tries an exact match first, then the primary
 * language subtag. E.g. `'fr-CA'` matches `'fr-CA'` exactly, then `'fr'`,
 * then falls back to `'en'`.
 */
export function resolveLocale(
    initLang: string | undefined,
    navigatorLang: string | undefined = typeof navigator !== 'undefined'
        ? navigator.language
        : undefined
): Locale {
    for (const candidate of [initLang, navigatorLang]) {
        if (!candidate) continue;
        const lower = candidate.toLowerCase();
        const exact = SUPPORTED.find(l => l === lower);
        if (exact) return exact;
        const primary = lower.split('-')[0];
        const partial = SUPPORTED.find(l => l.split('-')[0] === primary);
        if (partial) return partial;
    }
    return 'en';
}
